(function ($) {
  //loadPosts();

  $(".home-slider__content").slick({
    fade: true,
    speed: 700
  });
  // $(".home-slider__content").on("init", function (event, slick) {
  //   setTimeout(() => {
  //     document.querySelector(".home-slider__content").classList.add("active");
  //   }, 50);
  // });

  $(".highlights-bottom__carousel").slick({
    fade: true,
    speed: 700
  });

  // $(".home-slider__content").on(
  //   "beforeChange",
  //   function (event, slick, currentSlide, nextSlide) {
  //     $(".home-slider__content").removeClass("active");
  //   }
  // );

  // $(".home-slider__content").on(
  //   "afterChange",
  //   function (event, slick, currentSlide) {
  //     $(".home-slider__content").addClass("active");
  //   }
  // );

  $(".project-details__gallery-view").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: ".project-details__gallery-nav"
  });
  $(".project-details__gallery-nav").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".project-details__gallery-view",
    dots: false,
    focusOnSelect: true,
    arrows: false
  });
  setTimeout(function () {
    document.querySelector("body").classList.add("loaded");
  }, 800);
  scrollDown();
  window.addEventListener("scroll", function (e) {
    scrollDown();
  });
})(jQuery);
document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll(".overlay-menu__primary-nav li");
  const images = document.querySelectorAll(".overlay-menu__images img");
  menuItems.forEach(item => {
    item.addEventListener("mouseenter", function () {
      const id = item.getAttribute("data-menu-item-id");
      images.forEach(img => {
        if (img.getAttribute("data-menu-image-id") === id) {
          img.classList.add("active");
        } else {
          img.classList.remove("active");
        }
      });
    });
    item.addEventListener("mouseleave", function () {
      images.forEach(img => {
        img.classList.remove("active");
      });
    });
  });
  const horizontalSection = document.querySelector(".scroll-bullets");
  if (horizontalSection) {
    // const items = gsap.utils.toArray(".item");
    // gsap.registerPlugin(ScrollTrigger);
    // let scrollTween = gsap.to(items, {
    //   xPercent: -100 * (items.length - 0.5),
    //   ease: "none",
    //   scrollTrigger: {
    //     start: "0",
    //     trigger: ".scroll-bullets",
    //     pin: true,
    //     scrub: 0.1,
    //     end: () => `+=5000`,
    //   },
    // });
    // document.querySelectorAll(".item").forEach((item, index) => {
    //   let bulletElement = item.querySelector(".scroll-item__bullet img");
    //   gsap.set(bulletElement, {
    //     clipPath: "circle(20%)",
    //     opacity: 1,
    //   });
    //   gsap.to(bulletElement, {
    //     clipPath: "circle(50%)",
    //     scrollTrigger: {
    //       trigger: bulletElement,
    //       containerAnimation: scrollTween,
    //       start: "left center",
    //       scrub: true,
    //       start: "center 100%",
    //       end: "center 60%",
    //       id: index,
    //     },
    //     onComplete: () => {
    //       gsap.set(bulletElement, {
    //         clipPath: "circle(50%)",
    //         opacity: 1,
    //       });
    //     },
    //   });
    //   gsap.to(bulletElement, {
    //     clipPath: "circle(20%)",
    //     webkitClipPath: "circle(20%)",
    //     opacity: 0,
    //     scrollTrigger: {
    //       trigger: bulletElement,
    //       containerAnimation: scrollTween,
    //       start: "left center",
    //       //pin: true,
    //       scrub: true,
    //       start: "center 60%",
    //       end: "center -10%",
    //       id: index,
    //     },
    //   });
    // });
  }
});
document.querySelector(".header__open-menu").addEventListener("click", function () {
  document.querySelector(".header").classList.toggle("menu-open");
  document.querySelector("body").classList.add("no-scroll");
});
const accordItems = document.getElementsByClassName("acc-item");
if (accordItems) {
  for (let i = 0; i < accordItems.length; i++) {
    const cardButton = accordItems[i].querySelector(".acc-item__button");
    cardButton.addEventListener("click", () => {
      if (accordItems[i].classList.contains("active")) {
        accordItems[i].classList.remove("active");
      } else {
        for (let s = 0; s < accordItems.length; s++) {
          accordItems[s].classList.remove("active");
        }
        accordItems[i].classList.add("active");
      }
    });
  }
}
const accordeonHeading = document.querySelector(".accordion h2");
if (accordeonHeading) {
  const headingSpan = accordeonHeading.querySelector("span").innerHTML;
  const fullText = accordeonHeading.textContent;
  const outsideSpanText = fullText.replace(headingSpan, "").trim();
  //const headingText = tempSpan.textContent;
  console.log("headingSpan", headingSpan);
  console.log("headingText", outsideSpanText);
  accordeonHeading.innerHTML = `<div class="heading-span animate-fade"><span>${headingSpan}</span></div><div class="outside-span animate-fade"><span>${outsideSpanText}</span></div>`;
}